import styled, { CSSObject } from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import Typography from '@portalterreno/react-ui-core/Typography';

const mobileStyles: CSSObject = {
  marginTop: 11,
  marginBottom: 0
};

const desktopStyles: CSSObject = {
  marginTop: 0,
  marginBottom: 8
};

const StyledTitle = styled(Typography)({
  fontSize: '26px',
  [media('xs')]: mobileStyles,
  [media('lg')]: desktopStyles
});

export default StyledTitle;
